(function () {
  pagination(false);

  var observer = new IntersectionObserver(
    function (entries) {
      let logo = document.querySelector(".gh-head-logo");
      console.log(entries[0]);
      if (
        entries[0].isIntersecting === false &&
        logo.classList.contains("hidden")
      ) {
        logo.classList.remove("hidden");
        logo.classList.add("visible");
        document.querySelector(".headerCenterLogo").classList.remove("hidden");
        document.querySelector(".headerCenterLogo").classList.add("visible");
      } else if (
        entries[0].isIntersecting === true &&
        logo.classList.contains("visible")
      ) {
        console.log("showing!");
        logo.classList.remove("visible");
        logo.classList.add("hidden");
        document.querySelector(".headerCenterLogo").classList.remove("visible");
        document.querySelector(".headerCenterLogo").classList.add("hidden");
      }
    },
    { threshold: [0.37] }
  );
  let hpl = document.querySelector(".gh-head-logo-hp");
  console.log(hpl);
  if (hpl) {
    document.querySelector(".gh-head-logo").classList.add("hidden");
    document.querySelector(".headerCenterLogo").classList.add("hidden");
    observer.observe(hpl);
  }
})();
